import React, { useContext, useState } from "react";
import { Spinner } from "react-bootstrap";
import { toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../../../utilities/url";
import axios from "axios";
import storage from "../../../services/storage";
import { LuBookCopy } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { BiWorld } from "react-icons/bi";
import { FaTrash } from "react-icons/fa";
import {
  GrDocument,
  GrDocumentImage,
  GrDocumentSound,
  GrDocumentTxt,
  GrDocumentVideo,
} from "react-icons/gr";
import { formatFileSize } from "../../../utilities/ext-function";

const TableList = ({ cards, loading, onHandleDelete }) => {
  const navigate = useNavigate();

  const handleDownload = async (fileUrl) => {
    const proxyUrl =
      API_URL + `proxy-media-download?url=${encodeURIComponent(fileUrl)}`;
    window.location.href = proxyUrl;
  };

  const handleDelete = (id, filesize) => {
    onHandleDelete(id, filesize);
  };

  return (
    <div className="table-responsive">
      <table className="table table-striped table-bordered table-custome">
        <thead className="text-light">
          <tr className="fs-15">
            <th className="p-2">File Name</th>
            <th className="p-2">Media ID</th>
            <th className="p-2">Description</th>
            <th className="p-2">File Size</th>
            <th className="p-2">Media Type</th>
            <th className="p-2">Extension</th>
            <th className="p-2">Uploader</th>
            <th className="text-center p-2">Action</th>
          </tr>
        </thead>
        <tbody>
          {!loading ? (
            cards.length > 0 ? (
              <>
                {cards.map((card, index) => (
                  <tr key={index}>
                    <td className="align-middle p-2">
                      <div className="d-flex align-items-center">
                        {card.media_type === "image" && (
                          <GrDocumentImage size={20} className="me-3" />
                        )}
                        {card.media_type === "document" && (
                          <GrDocument size={20} className="me-3" />
                        )}
                        {card.media_type === "text" && (
                          <GrDocumentTxt size={20} className="me-3" />
                        )}
                        {card.media_type === "audio" && (
                          <GrDocumentSound size={20} className="me-3" />
                        )}
                        {card.media_type === "video" && (
                          <GrDocumentVideo size={20} className="me-3" />
                        )}
                        <a
                          className="link"
                          onClick={() => handleDownload(card.url_path)}
                        >
                          {card.name}
                        </a>
                      </div>
                    </td>
                    <td className="align-middle p-2">{card.fileid}</td>
                    <td className="align-middle p-2">
                      {card.description ? card.description : "-"}
                    </td>
                    <td className="align-middle text-end p-2">
                      {formatFileSize(card.filesize)}
                    </td>
                    <td className="align-middle p-2">{card.media_type}</td>
                    <td className="align-middle p-2">{card.extension}</td>
                    <td className="align-middle p-2">{card.uploader}</td>
                    <td className="align-middle text-center p-2">
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDelete(card.fileid, card.filesize)}
                        title="Delete"
                      >
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))}
              </>
            ) : (
              <tr>
                <td colspan="8">
                  <div className="text-center fs-14 my-5">No Data</div>
                </td>
              </tr>
            )
          ) : (
            <tr>
              <td colspan="8">
                <div
                  class="w-100 d-flex justify-content-center align-items-center"
                  style={{ height: "315px" }}
                >
                  <div class="loading-backdrop-2">
                    <div class="spinner-border"></div>
                  </div>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TableList;
